import { render, staticRenderFns } from "./batchAddALiForm.vue?vue&type=template&id=0e097ca7&scoped=true"
import script from "./batchAddALiForm.vue?vue&type=script&lang=js"
export * from "./batchAddALiForm.vue?vue&type=script&lang=js"
import style0 from "./batchAddALiForm.vue?vue&type=style&index=0&id=0e097ca7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e097ca7",
  null
  
)

export default component.exports